import { Component, input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-billing-line-items-renderer',
  standalone: true,
  imports: [
    MatListModule,
    MatFormFieldModule
  ],
  templateUrl: './billing-line-items-renderer.component.html',
  styleUrl: './billing-line-items-renderer.component.scss'
})
export class BillingLineItemsRendererComponent {
  control = input.required<ReportControl>();
}
